import { Injectable } from '@angular/core';
import { MyHeader } from '../config/myHeader';
import { HttpClient } from '@angular/common/http';
import { DataComparison } from '../models/DataComparison';
import { environment } from '../../environments/environment';
import { DeviceRg } from '../models/DeviceRg';
import { DeviceBit } from '../models/DeviceBit';
import { Syncro } from '../models/Syncro';

@Injectable({
  providedIn: 'any'
})
export class AccueilService {
  constructor(private http:HttpClient) { }

  public getDataComparisonFromCodeDivalto(codeDivalto: string){
    return this.http.get<DataComparison>(`${environment.urlBackend}client/comparison?tiers=` + codeDivalto);
  }

  public getDevicesRgFromCodeDivalto(codeDivalto: any){
    return this.http.get<DeviceRg[]>(`${environment.urlBackend}device/allRg?codeDivalto=` + codeDivalto);
  }

  public getDevicesBitFromCodeDivalto(codeDivalto: any){
    return this.http.get<DeviceBit[]>(`${environment.urlBackend}device/allBit?codeDivalto=` + codeDivalto);
  }

  public getSyncros(){
    return this.http.get<Syncro[]>(`${environment.urlBackend}syncro/all`);
  }

  public getDeviceRgUpdated(name:string, libelleRg: string){
    return this.http.get<DeviceRg>(`${environment.urlBackend}device/rg/data-updated?name=${name}&libelleRg=${libelleRg}`);
  }

  public downloadCsv(idSyncro: any){
    return this.http.get(`${environment.urlBackend}comparison/export?idSyncro=${idSyncro}`, {
      responseType: 'blob'
    })
  }
}
